var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDualshockers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 -1 102 102",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100,0v100H0V0H100z M92.3,7.7H7.7v84.6h84.6V7.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,76.9v7.7h-7.7v-7.7H38.5z M30.8,53.8v-7.7h7.7v-7.7h7.7v-7.7h7.7v-7.7h7.7v15.4h-7.7v7.7 h15.4v7.7h-7.7v7.7h-7.7v7.7h-7.7v7.7h-7.7V61.5h7.7v-7.7H30.8z M69.2,15.4v7.7h-7.7v-7.7H69.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDualshockers);
export default __webpack_public_path__ + "static/media/dualshockers.eafe76907dd1d9bde0179b845505115a.svg";
export { ForwardRef as ReactComponent };